import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IShippingLogistic } from '@/shared/model/shipping-logistic.model';

const baseApiUrl = 'api/shipping-logistics';
const baseSearchApiUrl = 'api/_search/shipping-logistics?query=';

export default class ShippingLogisticService {
  public search(query, paginationQuery): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(`${baseSearchApiUrl}${query}&${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public find(id: number): Promise<IShippingLogistic> {
    return new Promise<IShippingLogistic>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IShippingLogistic): Promise<IShippingLogistic> {
    return new Promise<IShippingLogistic>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IShippingLogistic): Promise<IShippingLogistic> {
    return new Promise<IShippingLogistic>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
